import * as Yup from 'yup'

export default Yup.object().shape({
  date: Yup.string()
    .required('screens.uploadDocument.dateRequired')
    .matches(/^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[012])\/\d{4}$/, 'screens.uploadDocument.dateFormat')
    .test('date', 'screens.uploadDocument.dateNotPrevious', function(value) {
      const minDate = new Date()
      const [day, month, year] = value.split('/').map(Number);
      const date = new Date(year, month - 1, day);
      minDate.setHours(0, 0, 0, 0) // set to midnight today
      return date.getTime() > minDate.getTime()
    }),
  file: Yup.string()
    .required(`screens.uploadDocument.fileRequired`),
})